import React from "react";

/**
 * GirlyGrove brand logo — official PNG with a subtle gold shimmer sweep.
 * Shimmer is a thin diagonal gradient that glides across every ~5s.
 */
const GroveLogo = ({ height = 40, className = "" }) => (
  <span
    className={`gg-logo-shimmer relative inline-block ${className}`}
    style={{ height, lineHeight: 0 }}
  >
    <style>{`
      @keyframes ggLogoShine {
        0%   { transform: translateX(-140%) skewX(-18deg); }
        60%  { transform: translateX(260%)  skewX(-18deg); }
        100% { transform: translateX(260%)  skewX(-18deg); }
      }
      .gg-logo-shimmer { overflow: hidden; }
      .gg-logo-shimmer::after {
        content: "";
        position: absolute;
        top: -10%;
        left: 0;
        height: 120%;
        width: 38%;
        background: linear-gradient(
          110deg,
          rgba(255,255,255,0) 0%,
          rgba(255,229,168,0.55) 45%,
          rgba(255,255,255,0.85) 50%,
          rgba(255,229,168,0.55) 55%,
          rgba(255,255,255,0) 100%
        );
        mix-blend-mode: screen;
        filter: blur(2px);
        pointer-events: none;
        animation: ggLogoShine 5.2s ease-in-out infinite;
      }
    `}</style>
    <img
      src="/girlygrove-logo.png"
      alt="GirlyGrove"
      style={{ height, width: "auto", display: "block", objectFit: "contain" }}
    />
  </span>
);

export default GroveLogo;

